import React, { useState, useEffect } from 'react';
import { Col, Row, Button } from 'reactstrap';
import TextField from '../../../../components/TextField/TextField';
import TabelaVeiculos from './TabelaVeiculos';
import { showMessage, showQuestion } from '../../../../helpers/message';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import implemento_api from '../../../../api/tiposImplemento_api';
import tiposImplemento_api from '../../../../api/tiposImplemento_api';
import moment from 'moment';
import mascaras from '../../../../helpers/mascaras';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
// estado inicial para o estado de veiculo
function initialStateVeiculo() {
    return {
        placa: "",
        renavan: "",
        status: "Ativo",
        vistoria: "",
        validade: "",
        categoria: "",
        propriedade: "",
        marcaModelo: "",
        anoFabricacaoChassi: "",
        capacidade: "0,00",
        tara: "0,00",
        cor: "",
        anoImplemento: "",
        observacao: "",
        implemento: {},
        modalidades: []
    }
}
export default function Veiculos({ transportador, setTransportador, errors, setErrors, openForm, setOpenForm }) {
    //guarda os dados de um veiculo
    const [veiculo, setVeiculo] = useState(initialStateVeiculo);
    //guarda as opções do select de implemento
    const [optionsImplemento, setOptionsImplemento] = useState([
    ]);
    //guarda as opções do select de modalidades
    const [optionsModalidades, setOptionsModalidades] = useState([]);
    // carrega assim que inicializada a tela as opções de implementos
    useEffect(() => {
        implemento_api.GetList("Ativo").then(response => {
            response.data = response.data.map(v => {
                return { value: v.id, label: v.descricao }
            })
            setOptionsImplemento([...optionsImplemento, ...response.data]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }, []);
    //campos para validação do veiculo
    const campos = [
        objCampo({ name: "placa", required: true, placa: true }),
        objCampo({ name: "vistoria", required: true }),
        objCampo({ name: "validade", required: true }),
        objCampo({ name: "anoFabricacaoChassi", required: true }),
        objCampo({ name: "anoImplemento", required: true }),
        objCampo({ name: "implemento", required: true }),
        objCampo({ name: "modalidades", required: true })
    ]
    // adiciona/edita um veiculo a lista de veiculos do transportador
    const addNovoVeiculo = () => {
        const erros = validarCampos(veiculo, campos);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        } else {
            setErrors({});
        }

        if (!veiculo.tableData) {
            const _veiculo = { ...veiculo };
            _veiculo.tara = _veiculo.tara.replace(",", ".");
            _veiculo.capacidade = _veiculo.capacidade.replace(",", ".");
            _veiculo.implemento = { id: _veiculo.implemento.value, descricao: _veiculo.implemento.label };
            _veiculo.modalidades = _veiculo.modalidades.map(value => { return { id: value.value, descricao: value.label } });

            setTransportador(transportadorAntigo => {
                return { ...transportadorAntigo, ...transportador, veiculos: [...transportador.veiculos, _veiculo] };
            });

            setOpenForm(false);
            setVeiculo(initialStateVeiculo);
            showMessage("Sucesso", "Sucesso ao adicionar o veiculo!", "success", null);
        } else {
            const _veiculos = [...transportador.veiculos];
            const _veiculo = { ...veiculo };
            delete _veiculo.tableData;
            _veiculo.tara = _veiculo.tara.replace(",", ".");
            _veiculo.capacidade = _veiculo.capacidade.replace(",", ".");
            _veiculo.implemento = { id: _veiculo.implemento.value, descricao: _veiculo.implemento.label };
            _veiculo.modalidades = _veiculo.modalidades.map(value => { return { id: value.value, descricao: value.label } });

            _veiculos[parseInt(veiculo.tableData.id)] = _veiculo;

            setTransportador(prevTransportador => { return { ...prevTransportador, ...transportador, veiculos: _veiculos } });
            setVeiculo(initialStateVeiculo);
            setOpenForm(false);
            showMessage("Sucesso", "Sucesso ao editar o veiculo!", "success", null);
        }
    }
    // guarda os dados do veiculo a ser editado no estado veiculo
    const editarVeiculo = (item) => {
        const _veiculo = { ...transportador.veiculos[item.tableData.id] }
        _veiculo.validade = moment(_veiculo.validade).format("YYYY-MM-DD");
        _veiculo.vistoria = moment(_veiculo.vistoria).format("YYYY-MM-DD");
        _veiculo.tara = _veiculo.tara.toString().replace(",", ".");
        _veiculo.capacidade = _veiculo.capacidade.toString().replace(",", ".");
        _veiculo.implemento = { value: _veiculo.implemento.id.toString(), label: _veiculo.implemento.descricao };
        _veiculo.modalidades = _veiculo.modalidades.map(v => {
            return { label: v.descricao, value: v.id };
        })
        _veiculo.tableData = {};
        _veiculo.tableData.id = item.tableData.id.toString();
        setErrors({});
        loadOptionsModalidades(_veiculo.implemento.value);
        setVeiculo(_veiculo);
        setOpenForm(true);
    }
    //remove um veiculo que ainda não foi salvo no banco da lista
    const removerVeiculo = (item) => {
        showQuestion("Aviso", "Tem certeza que deseja deletar este veiculo? Esta ação é irreversível", "info", (confirmation) => {
            if (confirmation) {
                const _veiculos = [...transportador.veiculos];
                _veiculos.splice(item.tableData.id, 1);
                setTransportador({ ...transportador, veiculos: [..._veiculos] });
            }
        })
    };
    // onChange para select de que aceita mais de uma opção com validação de erros assim que alterado o campo
    const onChangeMultiSelect = (e, select) => {
        const _veiculo = { ...veiculo, [select.name]: e };
        const campo = campos.filter(c => c.name == select.name);
        const erros = validarCampos(_veiculo, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[select.name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        if (select.name == "implemento" && e.value != "") {
            _veiculo.modalidades = [];
            loadOptionsModalidades(e.value);
        } else if (select.name == "implemento") {
            _veiculo.modalidades = [];
            setOptionsModalidades([]);
        }
        setVeiculo(_veiculo);
    }
    //select para os outros campos com validação de erros assim que alterado o campo
    const onChangeVeiculo = (e, select) => {
        const { name, value } = e.target;

        const _veiculo = { ...veiculo, [name]: name == "placa" ? value.toUpperCase() : value };

        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_veiculo, campo);


        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }



        setVeiculo(_veiculo);

    }
    //carrega as opções das modalidades ao se escolher um implemento
    const loadOptionsModalidades = (id) => {
        tiposImplemento_api.GetModalidades(id).then(response => {
            response.data = response.data.map(value => {
                return { label: value.descricao, value: value.id };
            })
            setOptionsModalidades(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error");
        })
    }

    return (
        <div>
            <div className={`formContainer ${openForm ? "" : "close"}`}>
                <Row>
                    <Col md="12" lg="4">
                        <TextField mask={mascaras.placaMask} maxLength={"8"} label="* Placa" name={"placa"} value={veiculo.placa} onChange={onChangeVeiculo} invalid={errors.placa ? true : false} />
                        {errors.placa && <span className={"form-control-label text-danger"}>{errors.placa.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label="* Vistoria" type={"date"} name={"vistoria"} value={veiculo.vistoria} onChange={onChangeVeiculo} invalid={errors.vistoria ? true : false} />
                        {errors.vistoria && <span className={"form-control-label text-danger"}>{errors.vistoria.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label="* Validade" type={"date"} name={"validade"} value={veiculo.validade} onChange={onChangeVeiculo} invalid={errors.validade ? true : false} />
                        {errors.validade && <span className={"form-control-label text-danger"}>{errors.validade.message}</span>}
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <TextField maxLength={"150"} label="Marca/Modelo" name={"marcaModelo"} value={veiculo.marcaModelo} onChange={onChangeVeiculo} invalid={errors.marcaModelo ? true : false} />
                        {errors.marcaModelo && <span className={"form-control-label text-danger"}>{errors.marcaModelo.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label="* Tipo do implemento" type={"select"} searchable options={optionsImplemento} name={"implemento"} value={veiculo.implemento} onChange={onChangeMultiSelect} invalid={errors.implemento ? true : false} />
                        {errors.implemento && <span className={"form-control-label text-danger"}>{errors.implemento.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField maxLength={"25"} label="Propriedade" type={"select"} options={[{ value: "Próprio", text: "Próprio" }, { value: "Locado", text: "Locado" }]} name={"propriedade"} value={veiculo.propriedade} onChange={onChangeVeiculo} invalid={errors.propriedade ? true : false} />
                        {errors.propriedade && <span className={"form-control-label text-danger"}>{errors.propriedade.message}</span>}
                    </Col>


                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <TextField mask={mascaras.numeroMask} maxLength={"30"} label="* Ano fabricação chassi" name={"anoFabricacaoChassi"} value={veiculo.anoFabricacaoChassi} onChange={onChangeVeiculo} invalid={errors.anoFabricacaoChassi ? true : false} />
                        {errors.anoFabricacaoChassi && <span className={"form-control-label text-danger"}>{errors.anoFabricacaoChassi.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField mask={mascaras.floatMask} label="Capacidade (TN)" name={"capacidade"} value={veiculo.capacidade} onChange={onChangeVeiculo} invalid={errors.capacidade ? true : false} />
                        {errors.capacidade && <span className={"form-control-label text-danger"}>{errors.capacidade.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField mask={mascaras.floatMask} label="Tara (TN)" name={"tara"} value={veiculo.tara} onChange={onChangeVeiculo} invalid={errors.tara ? true : false} />
                        {errors.tara && <span className={"form-control-label text-danger"}>{errors.tara.message}</span>}
                    </Col>

                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <TextField label="Status" type={"select"} options={[{ value: "Ativo", text: "Ativo" }, { value: "Inativo", text: "Inativo" }]} name={"status"} value={veiculo.status} onChange={onChangeVeiculo} invalid={errors.status ? true : false} />
                        {errors.status && <span className={"form-control-label text-danger"}>{errors.status.message}</span>}
                    </Col>

                    <Col md="12" lg="4">
                        <TextField maxLength={"4"} mask={mascaras.numeroMask} label="* Ano do implemento" name={"anoImplemento"} value={veiculo.anoImplemento} onChange={onChangeVeiculo} invalid={errors.anoImplemento ? true : false} />
                        {errors.anoImplemento && <span className={"form-control-label text-danger"}>{errors.anoImplemento.message}</span>}
                    </Col>
                    <Col md="12" lg="4">
                        <TextField maxLength={"100"} label="Cor" name={"corImplemento"} value={veiculo.corImplemento} onChange={onChangeVeiculo} invalid={errors.corImplemento ? true : false} />
                        {errors.corImplemento && <span className={"form-control-label text-danger"}>{errors.corImplemento.message}</span>}
                    </Col>

                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label="* Modalidade de coleta" options={optionsModalidades} type={"select"} multiple={true} name={"modalidades"} value={veiculo.modalidades} onChange={onChangeMultiSelect} invalid={errors.modalidades ? true : false} />
                        {errors.modalidades && <span className={"form-control-label text-danger"}>{errors.modalidades.message}</span>}
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label="Observações" type={"textarea"} name={"observacoes"} value={veiculo.observacoes} onChange={onChangeVeiculo} invalid={errors.observacoes ? true : false} />
                        {errors.observacoes && <span className={"form-control-label text-danger"}>{errors.observacoes.message}</span>}
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mb-4'>
                        <Button color={veiculo.id ? 'warning text-light' : 'success'} className='bg-gradient' onClick={addNovoVeiculo}>{veiculo.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : <>+ Adicionar</>}</Button>
                        <Button className='ms-4 bg-gradient' onClick={() => {
                            setOpenForm(false);
                            setVeiculo(initialStateVeiculo);
                        }}>Cancelar</Button>
                    </Col>
                </Row>
            </div>
            <div className="mt-4">
                <TabelaVeiculos title='Lista de veículos' search={true} veiculos={transportador.veiculos} editarVeiculo={editarVeiculo} removerVeiculo={removerVeiculo} />
            </div>
        </div>
    );

}